import { useEvidencePermission } from '@utils/permission-hook';
import React from 'react';
import { useIntl } from 'react-intl';
import {
  DictionaryEvidence,
  EmptyComponent,
  Evidence,
  updateItemFactory,
} from '@eas/common-web';
import { DataSource } from '@models';
import { useColumns } from './data-source-columns';
import { Fields } from './data-source-fields';
import { useValidationSchema } from './data-source-schema';
import { DataSourceActionbar } from './data-source-actionbar';
import { preProcess } from './data-source-utils';
import { EvidenceApiUrl, Permission } from '@enums';

export function DataSources() {
  const intl = useIntl();

  const validationSchema = useValidationSchema();

  const permissions = useEvidencePermission({
    options: {
      NEW: [],
      EDIT: [Permission.Default.ADMINISTRATOR],
      REMOVE: [],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [Permission.Default.ADMINISTRATOR],
      CHECK: [Permission.Default.ADMINISTRATOR],
      SAVE: [Permission.Default.ADMINISTRATOR],
      CLOSE: [Permission.Default.ADMINISTRATOR],
    },
  });

  const evidence = DictionaryEvidence.useDictionaryEvidence<DataSource>({
    version: 2,
    identifier: 'DATA_SOURCES',
    apiProps: {
      url: EvidenceApiUrl.DATA_SOURCE,
      updateItem: updateItemFactory({
        preProcess,
      }),
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'TAPIS__DATA_SOURCES__TABLE__TITLE',
        defaultMessage: 'Správa zdrojů informací',
      }),
      showReportButton: false,
    },
    detailProps: {
      FieldsComponent: Fields,
      GeneralFieldsComponent: EmptyComponent,
      validationSchema,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__DATA_SOURCES__DETAIL__TITLE',
          defaultMessage: 'Správa zdrojů informací',
        }),
        showBtn: permissions,
        ActionBar: DataSourceActionbar,
      },
    },
  });

  return <Evidence {...evidence} />;
}
